import { Middleware } from '@reduxjs/toolkit';
import jwt_decode from 'jwt-decode';

import { getAccessToken } from '../../Functions/LocalStorageUtils';

export interface DecodedToken {
  exp: number;
  iat: number;
  iss: string;
  jti: string;
}
// api ass the MiddlewareAPI object, which has access to the store - can be passed to as argument to first function
export const authCheck: Middleware = () => (next) => async (action) => {
  if (getAccessToken()) {
    const decoded: DecodedToken = jwt_decode(getAccessToken());
    if (decoded.exp < Date.now() / 1000) {
    }
  }
  return next(action);
};

export default authCheck;
